<template>
  <TopbarSpeedDial :buttons="buttonsConfig" :routeKey="routeKey"/>
</template>


<script>
/* @flow */
const TopbarSpeedDial = () =>
  import(/* webpackChunkName: "TopbarSpeedDial" */ '@/components/TopbarSpeedDial')

export default {
  name: 'DeviceGroupSpeedDial',
  props: {
    routeName: {type: String, default: ''},
    routeKey: {type: String, default: ''},
  },
  data() {
    return {
      buttonsConfig: [
        {
          label: 'Create new group',
          icon: 'add',
          to: 'new',
        },
      ],
    }
  },
  components: {
    TopbarSpeedDial,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/DeviceGroupSpeedDial.vue